import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { compose, hoistStatics, lifecycle, withHandlers, withState, withProps } from 'recompose';
import { matchPath, withRouter } from 'react-router-dom';

import WithLoading from '../../../../../components/WithLoading';
import Conversations from './Conversations';
import ChannelsService from '../../../../../services/channels.service';
import mh from '../../../../../helpers/messenger.helper';
import { messageActions } from '../../../../../reducers/messages';

const loadMore = props => async (nextPage) => {
  const {
    setChannelsSorted,
    sortedChannelIds,
    changeChatAttr,
    setHasMore,
    criteria,
  } = props;
  const { data: { data, count, hasMore } } = await ChannelsService.getData({ ...criteria, offset: sortedChannelIds.length });
  const channelIds = [];
  for (let i = 0; i < data.length; i++) {
    channelIds.push(data[i].id);
    changeChatAttr({ channel_id: data[i].id, attributes: data[i] });
  }
  setChannelsSorted({ channelIds, direction: 1 });
  setHasMore(hasMore);
};


const defaultCriteria = {
  limit: 6,
  offset: 0,
};

const mapStateToProps = state => ({
  messenger: state.messenger,
  sortedChannelIds: state.messenger.sortedChannelIds,
});

const mapDispatchToProps = ({
  addChat: messageActions.addChat,
  clearMessenger: messageActions.clearMessenger,
  changeChatAttr: messageActions.changeChatAttr,
  setChannelsSorted: messageActions.setChannelsSorted,
});

const getActiveId = (props) => {
  let activeId;
  const match = matchPath(props.history.location.pathname, {
    path: '/messages/:id',
    exact: true,
    strict: false,
  });
  if (match && match.params && match.params.id !== undefined) {
    if (match.params.id !== 'create') {
      activeId = parseInt(match.params.id, 10);
    }
  }
  return activeId;
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('isLoading', 'setIsLoading', true),
  withState('hasMore', 'setHasMore', false),
  withState('criteria', 'setCriteria', defaultCriteria),
  translate('portal'),
  lifecycle({
    async componentDidMount() {
      await loadMore(this.props)(0);
      this.props.setIsLoading(false);
    },
  }),
  withProps(props => ({
    activeId: getActiveId(props),
  })),
  withHandlers({
    loadMore,
    startChat: mh.startChat,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Conversations)));



// WEBPACK FOOTER //
// ./src/views/modules/messages/startConversation/conversations/index.js